"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodigoPromocionalConverter = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
const CodigoPromocionalConverter = {
    toFirestore(codigoPromocional) {
        const obj = codigoPromocional;
        obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({
            buscableParcialPor: [obj.codigo, obj.empresaRUT, obj.empresaRazonSocial, obj.empresaNombre],
            buscableExactoPor: []
        });
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            mailNotificarGracias: data.mailNotificarGracias ?? "",
            codigo: data.codigo,
            empresa: data.empresa,
            empresaRUT: data.empresaRUT,
            empresaRazonSocial: data.empresaRazonSocial,
            empresaNombre: data.empresaNombre,
            mesesGratisEmpresa: data.mesesGratisEmpresa,
            mesesGratisRegistro: data.mesesGratisRegistro,
            activo: data.activo,
            query: data.query,
            activoHasta: data.activoHasta
        };
    }
};
exports.CodigoPromocionalConverter = CodigoPromocionalConverter;
